import InventoryType from '@/legacy/InventoryType';
import MakeModel from '@/legacy/MakeModel';
import TileKit from '@/legacy/TileKit';
import TrimMileage from '@/legacy/TrimMileage';
import PriceAndTerms from './PriceAndTerms';
import useMiddleFrameEvents from './useMiddleFrameEvents';

const MiddleFrame = () => {
  const { trackMarketPlaceClicked } = useMiddleFrameEvents();

  return (
    <TileKit.Frame className="middle-frame">
      <TileKit.Pane fullWidth>
        <InventoryType trackMarketPlaceClicked={trackMarketPlaceClicked} />
        <MakeModel />
        <TrimMileage />
      </TileKit.Pane>
      <PriceAndTerms />
    </TileKit.Frame>
  );
};

export default MiddleFrame;
